import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail_container"
}
const _hoisted_2 = {
  key: 0,
  class: "detail_base-info card-white-6"
}
const _hoisted_3 = { class: "detail_header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "客户基本信息", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("终止")
const _hoisted_6 = {
  key: 1,
  class: "detail_base-info card-white-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "detail_header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "额度信息")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 申请Normal额度 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Head审核触发比例 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" GM审核触发金额 ")
const _hoisted_11 = {
  key: 2,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_12 = { class: "hw_detail_table_header" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 历史回款数据 ")
const _hoisted_15 = {
  key: 3,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "hw_detail_table_header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "历史申请记录")
], -1)
const _hoisted_17 = {
  key: 4,
  class: "card-white-6 hw_detail_table_container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps(_ctx.$attrs, {
    collapsed: true,
    title: _ctx.title,
    drop_down_menus: _ctx.get_drop_down_menus
  }), {
    default: _withCtx(() => [
      (!_ctx.isEmptyData(_ctx.detail_data))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.isEmptyData(_ctx.company_info) && !_ctx.isEmptyData(_ctx.credit_info))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", null, [
                      (_ctx.canCancel)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            class: "mglf-16",
                            type: "primary",
                            onClick: _ctx.cancelWorkflow
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_a_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, {
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "客户名称",
                                name: "rd_company_name",
                                labelCol: { style: `width:66px` },
                                wrapperCol: { style: `max-width:calc(100% - 66px)` }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.credit_info.rd_company_name,
                                    edit: _ctx.editMode
                                  }, {
                                    text: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "link",
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jumpToCompany(_ctx.credit_info.company_id))),
                                        class: "text-ellipsis"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.credit_info.rd_company_name), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              }, 8, ["wrapperCol"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "是否双签",
                                name: "double_sign"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.getTextFromValue(_ctx.get_double_sign_items, Number(_ctx.company_info.double_sign), 'id', 'name'),
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "合作情况",
                                name: "deep_pocket"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.company_info.deep_pocket,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "友商口碑",
                                name: "agency_public_praise"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.company_info.agency_public_praise,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "预计我司合作规模",
                                name: "month_expend_amount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.company_info.month_expend_amount,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "实控人背景信息",
                                name: "team_background"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.company_info.team_background,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "经营现状",
                                name: "operate_situation"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.company_info.operate_situation,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "客户合同",
                                name: "contract_list"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    edit: _ctx.editMode,
                                    spanWrapperClass: "spanWrapperClass"
                                  }, {
                                    text: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company_info.contract_list, (item) => {
                                        return (_openBlock(), _createBlock(_component_a_button, {
                                          type: "link",
                                          key: item.name,
                                          onClick: ($event: any) => (_ctx.jumpToContract(item)),
                                          style: {"display":"block","padding-left":"0"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(`${item.name}(${item.rd_state_name})`), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEmptyData(_ctx.credit_info))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_a_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, {
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { name: "apply_limit_amount" }, {
                                label: _withCtx(() => [
                                  _hoisted_8,
                                  _createVNode(_component_a_tooltip, { title: "如需修改申请额度，可点击提交申请进行操作" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_svg_icon, {
                                        iconName: "QuestionCircleOutlined",
                                        style: {"color":"#999","font-size":"16px"}
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.credit_info.apply_limit_amount,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.credit_info.property !== 'Normal')
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 0,
                                span: 8,
                                xxl: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "Prepay额度",
                                    name: "prepay_amount"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.formatNumberByNumeral(_ctx.credit_info.prepay_amount, '0.00'),
                                        edit: _ctx.editMode
                                      }, null, 8, ["value", "edit"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "期初余额",
                                name: "init_account_balance"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.credit_info.init_account_balance,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.credit_info.property !== 'Normal')
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 1,
                                span: 8,
                                xxl: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "head_review_exceed_percent" }, {
                                    label: _withCtx(() => [
                                      _hoisted_9,
                                      _createVNode(_component_a_tooltip, { title: "充值审核门槛" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.formatNumberByNumeral(_ctx.credit_info.head_review_exceed_percent, '0.0%'),
                                        edit: _ctx.editMode
                                      }, null, 8, ["value", "edit"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.credit_info.property !== 'Normal')
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 2,
                                span: 8,
                                xxl: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "gm_review_exceed_amount" }, {
                                    label: _withCtx(() => [
                                      _hoisted_10,
                                      _createVNode(_component_a_tooltip, { title: "充值审核门槛" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.formatNumberByNumeral(_ctx.credit_info.gm_review_exceed_amount, '$0,0'),
                                        edit: _ctx.editMode
                                      }, null, 8, ["value", "edit"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "授信说明",
                                name: "note"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.credit_info.note,
                                    edit: _ctx.editMode
                                  }, null, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEmptyData(_ctx.bill_amount_history))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_a_tooltip, { title: "客户近一年回款数据" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_we_table, _mergeProps(_ctx.history_aomunt_table_config, { dataSource: _ctx.bill_amount_history }), null, 16, ["dataSource"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEmptyData(_ctx.bill_apply_history))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_we_table, _mergeProps(_ctx.history_apply_table_config, { dataSource: _ctx.bill_apply_history }), null, 16, ["dataSource"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEmptyData(_ctx.flow))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_FlowTimeLine, {
                    flow: _ctx.flow,
                    onOnCatchFlag: _ctx.catchFlowFlag,
                    onOnUpdate: _ctx.initData
                  }, null, 8, ["flow", "onOnCatchFlag", "onOnUpdate"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["title", "drop_down_menus"])), [
    [_directive_loading, _ctx.isEmptyData(_ctx.detail_data)]
  ])
}